<bom-full-page [show]="isDiscardPendingChangesModalOpen$ | async" [focusTrapping$]="trapping$">
  <ng-container bom-fullpage-main>
    <ng-container>
      <h3>{{ 'Confirmation.Header' | tekstresource }}</h3>
    </ng-container>
    <ng-container>
      <div class="mt-3 mb-6">
        {{ 'Confirmation.Tekst' | tekstresource: { sidenavn: pageName } }}
      </div>
    </ng-container>
    <ng-container>
      <button
        class="button button-secondary"
        (click)="discardChanges.emit(false)"
        [attr.aria-label]="'Confirmation.Cancel' | tekstresource"
      >
        {{ 'Confirmation.Cancel' | tekstresource }}
      </button>
      <button
        class="button button-primary"
        [attr.aria-label]="'Confirmation.Confirm' | tekstresource"
        (click)="discardChanges.emit(true)"
      >
        {{ 'Confirmation.Confirm' | tekstresource }}
      </button>
    </ng-container>
  </ng-container>
</bom-full-page>
